module.exports = "<!-- start banner section -->\n<div class=\"banner\" *ngIf=\"headerBanner\" id=\"header-banner\">\n    <span class=\"hide-banner\" (click)=\"hideBanner()\"></span>\n    <a [href]=\"headerBanner.url\"><img [src]=\"headerBanner.image\" [alt]=\"\" class=\"img-responsive banner\"></a>\n</div>\n<!-- End banner section -->"


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/MartMax/components/home-page/header-banner/header-banner.component.html
// module id = ../../../../../src/app/MartMax/components/home-page/header-banner/header-banner.component.html
// module chunks = main